import { createApp } from 'vue'
import ArcoVue from '@arco-design/web-vue'
import ArcoVueIcon from '@arco-design/web-vue/es/icon'

import '@/styles/index.less'
import '@fe/zxwy-utils/styles/arco-design-reset.css'
import '@fe/zxwy-utils/styles/reset.css'

import components from '@/components/index.js'
import directives from '@/directives/index.js'
import router from '@/router/index.js'
import store from '@/store/index.js'
import utils from '@/utils/index.js'

import App from './App.vue'

// 创建主应用实例
createApp(App)
  .use(store)
  .use(router)
  .use(ArcoVue, { componentPrefix: 'arco' })
  .use(ArcoVueIcon)
  .use(components)
  .use(directives)
  .use(utils)
  .mount('#app')
